import { confirmSignIn } from "aws-amplify/auth";
import { Dispatch, SetStateAction, useState } from "react";
import TextInput from "../../../components/form-fields/TextInput";
import { ErrorMessage } from "../../../components/forms";
import SecondaryLayout from "../../../components/authentication/layout/SecondaryLayout";
import { errorMessage } from "../../../utils/error";
import { OnLoginResponse } from "../Login";
import { useTranslation } from "react-i18next";
import AuthenticationFlowActions from "../../../components/authentication/AuthenticationFlowActions";

interface IProps {
  onLoginResponse: OnLoginResponse;
}

const handleFormValidationAndSetError = (state: any, setError: Dispatch<SetStateAction<string>>, t: any) => {
  const { password, passwordConfirmation } = state;

  if (password !== passwordConfirmation) {
    setError(t("matchError"));
    return true; // Indicates validation failure
  }
  return false; // Indicates validation success
};

export const NewPasswordForm = ({ onLoginResponse }: IProps) => {
  const [state, setState] = useState({
    password: "",
    passwordConfirmation: "",
  });
  const [error, setError] = useState("");
  const { t } = useTranslation("pages", { keyPrefix: "auth.login.newPasswordForm" });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (handleFormValidationAndSetError(state, setError, t)) {
      return;
    }

    try {
      const response = await confirmSignIn({
        challengeResponse: state.password,
      });
      onLoginResponse(response);
    } catch (err) {
      setError(errorMessage(err));
    }
  };

  return (
    <SecondaryLayout>
      <form onSubmit={handleSubmit} className="mb-10  space-y-4">
        <div>
          <h2 className="font-serif font-bold md:font-semibold text-3xl md:text-4xl mb-4">{t("form.title")}</h2>
          <p className="md:text-lg font-normal mb-4">{t("form.content")}</p>
          <div className="md:max-w-[25rem] space-y-2">
            <TextInput
              type="password"
              label={t("form.newPassword")}
              value={state.password}
              onValueChange={value => setState({ ...state, password: value })}
              error={error.toLowerCase().includes("password")}
            />
            <TextInput
              type="password"
              value={state.passwordConfirmation}
              label={t("form.confirmPassword")}
              onValueChange={value => setState({ ...state, passwordConfirmation: value })}
              error={error.toLowerCase().includes("password")}
            />
          </div>
        </div>
        <ErrorMessage error={error} />
        <div className="!mt-8">
          <AuthenticationFlowActions nextLabel={t("form.button.next")} />
        </div>
      </form>
    </SecondaryLayout>
  );
};
